import { Routes } from '@angular/router';

import { CallbackComponent } from './auth/callback.component';
import { LoginComponent } from './auth/login.component';
import { CertificationHubComponent } from './certification/certification-hub.component';
import { SectionComponent } from './certification/section.component';
import { authenticatedGuard } from './guards/authenticated.guard';
import { certTakerGuard, inboxAccessGuard, staffOnlyGuard } from './guards/var-access.guards';
import { IntakeFormComponent } from './intake/intake-form.component';
import { QueueInboxComponent } from './queue-inbox/queue-inbox.component';
import { TicketDetailComponent } from './ticket-detail/ticket-detail.component';
import { AgentCertificationComponent } from './var-admin/agent-certification.component';
import { VarPrincipalReviewComponent } from './var-admin/var-principal-review.component';

export const APP_ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'inbox' },
  { path: 'callback', component: CallbackComponent },
  // Sign-in landing (staff + partner rails). Unguarded — this is where
  // authenticatedGuard sends unauthenticated visitors, so it must never require auth.
  { path: 'login', component: LoginComponent },
  // Anonymous carve-out (Task 5's SWA route rule) — the "I can't log in" door
  // must work with zero auth, so this route deliberately has no guard.
  { path: 'intake', component: IntakeFormComponent },
  // Inbox + ticket detail: staff always; a VAR only once certified (inboxAccessGuard
  // forces an uncertified VAR to the certification flow).
  { path: 'inbox', component: QueueInboxComponent, canActivate: [authenticatedGuard, inboxAccessGuard] },
  { path: 'tickets/:id', component: TicketDetailComponent, canActivate: [authenticatedGuard, inboxAccessGuard] },
  // VAR admin surfaces: staff only (staffOnlyGuard bounces a VAR to their own home).
  { path: 'var-admin/principals', component: VarPrincipalReviewComponent, canActivate: [authenticatedGuard, staffOnlyGuard] },
  { path: 'var-admin/certification', component: AgentCertificationComponent, canActivate: [authenticatedGuard, staffOnlyGuard] },
  // VAR-agent certification — section hub (Task 7, per-section quiz flow,
  // AB#1827 follow-on). VARs only (certTakerGuard bounces staff to the inbox).
  { path: 'certification', component: CertificationHubComponent, canActivate: [authenticatedGuard, certTakerGuard] },
  // VAR-agent certification — section page (Task 8, AB#1827 follow-on): module
  // content -> inline quiz -> inline result, all on one route. `:section` is
  // the domain slug the hub's cards link with. VARs only.
  { path: 'certification/section/:section', component: SectionComponent, canActivate: [authenticatedGuard, certTakerGuard] },
];
